(function () {
  const BLOCK_SELECTOR = '#also-bought-app-block';
  const BUTTON_SELECTOR = '.cbb-also-bought-add-to-cart-button';
  const CARD_SELECTOR = '.cbb-also-bought-product';
  const TITLE_LINK_SELECTOR = 'a[href^="/products/"]';
  const IMAGE_LINK_SELECTOR = 'a.cbb-also-bought-product-image-link[data-href]';

  function closestElement(target, selector) {
    let element = target;
    if (element && element.nodeType !== 1) {
      element = element.parentElement;
    }

    return element && typeof element.closest === 'function'
      ? element.closest(selector)
      : null;
  }

  function isAlsoBoughtButton(button) {
    if (!button) return false;
    return Boolean(button.closest(BLOCK_SELECTOR) || button.closest(CARD_SELECTOR));
  }

  function resolveRedirectUrl(button) {
    const card = button.closest(CARD_SELECTOR);
    if (!card) return null;

    const titleLink = card.querySelector(TITLE_LINK_SELECTOR);
    const titleHref = titleLink && titleLink.getAttribute('href');
    if (titleHref) return titleHref;

    const imageLink = card.querySelector(IMAGE_LINK_SELECTOR);
    return imageLink && imageLink.getAttribute('data-href');
  }

  function handleAlsoBoughtBuyNowClick(event) {
    const clickedButton = closestElement(event.target, BUTTON_SELECTOR);

    if (!isAlsoBoughtButton(clickedButton)) return;

    const redirectUrl = resolveRedirectUrl(clickedButton);
    if (!redirectUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(redirectUrl);
  }

  if (typeof document !== 'undefined' && !window.__alsoBoughtBuyNowRedirectBound) {
    document.addEventListener('click', handleAlsoBoughtBuyNowClick, true);
    window.__alsoBoughtBuyNowRedirectBound = true;
  }
})();
